import type { MessageKey } from '@bookingdei/i18n/message-key';

// Per-unit price suffixes the design localises ("/night" → "/রাত"). The API sends the
// suffix as a display string (CatalogItem.price_unit); known ones get a dictionary
// entry, anything else shows as sent. One map for every website screen that prints a
// price (home, search, trending, business page, booking stepper — DC122).
const UNIT_KEYS: Record<string, MessageKey> = {
  '/night': 'dc50.unit.night',
  '/hr': 'dc50.unit.hr',
  '/day': 'dc50.unit.day',
  '/visit': 'dc50.unit.visit',
  '/session': 'dc50.unit.session',
  '/class': 'dc50.unit.class',
  '/table': 'dc50.unit.table',
  '/person': 'dc50.unit.person',
  '/mo': 'dc50.unit.month',
  '/month': 'dc122.unit.month',
  '/week': 'dc122.unit.week',
  '/ticket': 'dc122.unit.ticket',
  '/booking': 'dc122.unit.booking',
  '/child': 'dc122.unit.child',
  '/sitting': 'dc122.unit.sitting',
  '/scan': 'dc122.unit.scan',
  // A turf field is always priced per slot (API-240 forces the unit, FR-B28).
  '/slot': 'turfweb.unit.slot',
};

export function priceUnitLabel(t: (key: MessageKey) => string, unit: string | undefined | null): string {
  if (!unit) return '';
  const key = UNIT_KEYS[unit];
  return key ? t(key) : unit;
}
